export default "__VITE_ASSET__BPHjFjQI__"